import React from "react";
import { pendingLogo } from "../../../assets/images";

const GifcardSent = ({ setOpenGicardDone, setDenominationData }: any) => {
  return (
    <div className="fixed inset-0 overflow-auto pb-16 flex font-manrope justify-start items-start pt-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-center px-3 md:px-6 items-center flex-col gap-4">
          <div className="w-[116px] h-[116px]">
            <img src={pendingLogo} className="w-full h-full bg-cover" alt="" />
          </div>
          <h4 className="font-sora font-bold text-center text-gray-900 dark:text-gray-100 text-[24px]">
            Transaction pending
          </h4>
          <h4 className=" font-medium text-gray-500 dark:text-gray-400 text-center text-[15px]">
            The trader has successfully received your cards. Funds will be sent
            as soon as the transaction is confirmed.
          </h4>
        </div>
        <button
          onClick={() => {
            setDenominationData([]);
            setOpenGicardDone(false);
          }}
          className="mt-16 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default GifcardSent;
